module.exports = __webpack_public_path__ + "img/player4.3d265341.png";